// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wX82","label":"styles_label__3vw5-"};